<template>
    <div class="load">
        <img class
             src="/img/load.gif"
             alt>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.load {
    padding: 2rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        height: 60px;
    }
}
</style>

